import { createNestedCircle } from "../components.utils";
import {
    ACTIVE_ENDPOINT, INACTIVE_ENDPOINT, DISABLED_ENDPOINT, ERROR_ENDPOINT
} from "../cell/grid-cell.config";

export class Endpoint {
    layout = {
        x: null, y: null, side: null, radius: null
    };

    state = {
        drawed: false, dir: null, active: null, connectorErrorState: false
    };

    ctx;

    constructor(layout, state, ctx) {
        this.layout = { ...this.layout, ...layout };
        this.state = { ...this.state, ...state };
        this.ctx = ctx;
    }

    draw() {
        const circlesRadius = [this.layout.radius, this.layout.radius / 2.5];
        const circlesFills = this.state.readonlyDisabled ? DISABLED_ENDPOINT : this.state.active ? ACTIVE_ENDPOINT : this.state.connectorErrorState ? ERROR_ENDPOINT : INACTIVE_ENDPOINT;
        createNestedCircle(this.layout.x, this.layout.y, circlesRadius, circlesFills, this.ctx);
        this.state.drawed = true;
    }

    update(layout, state) {
        if (layout) this.layout = { ...this.layout, ...layout };
        if (state) this.state = { ...this.state, ...state };
    }
}
